// extracted by mini-css-extract-plugin
export default {"tooltip-component":"TooltipComponent_tooltip-component__J-M42","tooltip-text":"TooltipComponent_tooltip-text__ETXmg"};